import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

import { ModuleRepositoryPort } from 'module/port/module-repository.port';
import { UserModuleSuggestion } from 'user/suggestion/user-module-suggestion';

import { AppLocator } from '../../../app.locator';

export interface UserModuleSuggestionDocument {
	readonly id: string;
	readonly userId: string;
	readonly priority: number;
	readonly orgModuleId: string;
}

export type UserModuleSuggestionsState = EntityState<
	UserModuleSuggestionDocument,
	string
>;

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'userModuleSuggestions' })
export class UserModuleSuggestionsStore extends EntityStore<UserModuleSuggestionsState> {
	constructor() {
		super();
	}

	public get _moduleRepositoryPort(): ModuleRepositoryPort {
		return AppLocator.inject(ModuleRepositoryPort);
	}

	public asDocument(entity: UserModuleSuggestion): UserModuleSuggestionDocument {
		return {
			id: `${entity.userId}:${entity.orgModuleId}`,
			priority: entity.priority,
			orgModuleId: entity.orgModuleId,
			userId: entity.userId,
		};
	}

	public asEntity(entity: UserModuleSuggestionDocument): UserModuleSuggestion {
		return new UserModuleSuggestion(
			entity.userId,
			entity.priority,
			entity.orgModuleId,
			this._moduleRepositoryPort.observeModuleById(entity.orgModuleId)
		);
	}
}
